// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__1La4F","content":"Consent_content__22FAR","footer":"Consent_footer__1f7ox"};